import http from '@/utils/request';
import { API_BASE } from '@/config';


export const getUnreadMesages = () => {
  const url = `${API_BASE}/global/messages/unread`;
  return http.get({
    url,
  });
};

// 图片上传 API 路径
// export const UPLOAD_FILE_API = `${API_BASE.base}/picture/upload`;
// export const UPLOAD_FILE_API = `${API_BASE.base}/file/store/upload`;
export const UPLOAD_FILE_API = `${API_BASE.base}/file/store/finance/upload`;
// 文件上传 API 路径
export const FILE_API = `${API_BASE.base}/files/upload`;

/**
 * 图片上传
 *
 * @param {*} data
 * @returns
 */
export const uploadFile = (data) => {
  return http.post({
    url: UPLOAD_FILE_API,
    data,
  });
};

/**
 * 获取 获取省市区数据
 *
 * @param {*} data
 * @returns
 */
export const getAreaTree = () => {
  const url = '/api/area/queryAllAreas';

  return http.get({
    server: 'open',
    url,
  });
};

/**
 * 获取 获取省市区数据
 *
 * @param {*} data
 * @returns
 */
export const getProvinceList = (data) => {
  const url = '/dicBankBranchEntity/H5/cityList';
  return http.post({
    url,
    data,
  });
};

/**
 * 金融产品列表
 *
 * @param {*} data
 * @returns
 */
export const getChannelList = (data) => {
  const url = '/credit/channel/channelList';
  return http.post({
    url,
    data,
    loading: false,
  });
};

/**
 * 业务归属列表
 *
 * @param {*} data
 * @returns
 */
export const getSourceList = (data) => {
  const url = '/credit/account/source';
  return http.post({
    url,
    data,
    loading: false,
  });
};

/**
 * 获取菜单权限
 *
 * @param {*} data
 * @returns
 */
export const getMenus = (data = {}) => {
  const url = '/authority/getMenuListByUser';

  return http.post({
    url,
    data,
  });
};

/**
 * 字典查询
 * @param {*} data
 * @returns
 */
export const getDictionaryType = (data = {}) => {
  const url = '/dicBankBranchEntity/constant';
  return http.post({
    url,
    data,
  });
};

// 根据codePath查询字典
export const getDictionaryByPathCodeList = (data = {}) => {
  return http.post({
    url: '/basedic/inner/dicItems_by_code_path_list',
    data,
  });
};

// 获取银行信息列表
export const getBankList = (data) => {
  const url = '/dicBankEntity/bankList';
  return http.post({
    url,
    data,
  });
};

// 查询银行支行信息
export const getBankBranchList = (data) => {
  return http.post({
    url: '/dicBankBranchEntity/bankBranchList',
    data,
  });
};

/**
 * 获取用户对应的业务归属
 * @param {*} data
 */
export const getSourceOfUser = (data) => {
  const url = '/authority/source/getSourceOfUser';
  return http.post({
    url,
    data,
  });
};

// 用户列表模板更新
export const saveOrUpdateUserTemplate = (data) => {
  const url = '/dictionary/common/userTemplate/saveOrUpdate';
  return http.post({
    url,
    data,
  });
};

// 用户列表模板获取
export const getUserTemplate = (data) => {
  const url = '/dictionary/common/userTemplate/getTemplate';
  return http.post({
    url,
    data,
  });
};

// 解密数据
export const getDecryptData = (data) => {
  return http.post({
    url: '/dictionary/common/getDecryptData',
    data,
  });
};

// 获取用户下载列表数据
export const getDownloadList = (data) => {
  return http.post({
    url: '/file_linker/center/history_list/FIN_SERVICE',
    data,
  });
};

// 公共导出
export const dataExport = (data, templateCode) => {
  return http.post({
    url: `/file_linker/center/createTask/FIN_SERVICE/${templateCode}`,
    data,
  });
};

// 查询报表生成结果
export const getDataExportResult = (data, templateCode) => {
  return http.post({
    url: `/file_linker/center/result/FIN_SERVICE/${templateCode}`,
    data,
  });
};

// 修改密码
export const modifyPassword = (data) => http.post({ url: '/authority/changePwdWithOldPwd', data });
